const ekeFilters = angular.module('ekeFilters', []);

const profile = { // TODO: put profiles to global scope/file
  lu: 'LU',
  qr: 'QR',
  vale: 'VALE',
  vr: 'VR',
  melco: 'MELCO',
  demo: 'DEMO'
};

ekeFilters.filter('secondsAgoUTC', function () {
  return function (date) {
    if (!date) {
      return '-';
    }

    // If the incoming ISO has no timezone (no Z / +/-HH:mm),
    // interpret it as profile-local time to avoid false offsets.
    const dt = parseReceivedDate(date);
    const relativeTime = dt.toRelative();

    if (relativeTime === null) {
      return '-';
    }
    return relativeTime;
  };
});

ekeFilters.filter('secondsAgoUTCUnix', function () {
  return function (date) {
    if (date === null || !Number.isInteger(date)) {
      return '-';
    }

    let offset = 0;
    if (__env.profile === profile.melco) {
      offset = 8;
    }
    const dateWithOffset = date - offset * 3600;
    const relativeTime = DateTime.fromSeconds(dateWithOffset).toRelative();
    return relativeTime;
  };
});

ekeFilters.filter('dataReceivedColor', function () {
  function dataReceivedColor(date) {
    const diff = parseReceivedDate(date).diffNow('seconds');
    const seconds = Math.abs(diff.toObject().seconds);

    if (date && seconds < 60) {
      return 'data-green';
    } else if (date && seconds >= 60 && seconds < 150) {
      return 'data-yellow';
    } else {
      return 'data-gray';
    }
  };

  dataReceivedColor.$stateful = true;
  return dataReceivedColor;
});

ekeFilters.filter('formatTimestampHoursUnix', function () {
  return function (date, timezone) {
    if (date === null || !Number.isInteger(date)) {
      return '-';
    }
    const dt = DateTime.fromSeconds(date);
    if (__env.profile === profile.lu) {
      const trainZonedDateTime = dt.setZone(timezone || 'local');
      return trainZonedDateTime.isValid ? trainZonedDateTime.setLocale(getLocaleBST()).toFormat('HH:mm:ss ZZZZ') : '-';
    }
    // For other profiles, return the time in UTC without timezone.
    return DateTime.fromSeconds(date).toUTC().toFormat("HH:mm:ss");
  }
});

ekeFilters.filter('formatTimestampHoursJSDate', function () {
  return function (date) {
    const converted = DateTime.fromJSDate(date, {zone: 'utc'}).toFormat('HH:mm:ss');
    if (converted === 'Invalid DateTime') {
      return '-';
    }
    return converted;
  };
});

ekeFilters.filter('formatTimestampDate', function () {
  return function (date) {
    const converted = DateTime.fromISO(date, {zone: 'utc'}).toFormat('dd.MM.yyyy');
    if (converted === 'Invalid DateTime') {
      return '-';
    }
    return converted;
  };
});

ekeFilters.filter('formatTimestampCustomFormat', function () {
  return function (date) {
    const converted = DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss').toFormat('dd.MM.yyyy');
    if (converted === 'Invalid DateTime') {
      return '-';
    }
    return converted;
  };
});

ekeFilters.filter('formatTimestamp', function () {
  return function (date) {
    const dt = DateTime.fromISO(date, { zone: 'utc' });
    if (__env.profile === profile.lu) {
      const localDt = dt.setZone('local');
      return localDt.isValid ? localDt.setLocale(getLocaleBST()).toFormat('dd.MM.yyyy HH:mm:ss ZZZZ') : '-';
    }
    return dt.isValid ? dt.toFormat('dd.MM.yyyy HH:mm:ss') : '-';
  };
});

ekeFilters.filter('formatSiteClockHours', function () {
  return function (date) {
    if (date === null || !Number.isInteger(date)) {
      return '-';
    }
    return DateTime
      .fromMillis(date, {zone: getTimezone()})
      .setLocale(getLocaleBST())
      .toFormat('HH:mm:ss ZZZZ');
  };
});

ekeFilters.filter('formatSiteClockDate', function () {
  return function (date) {
    if (date === null || !Number.isInteger(date)) {
      return '-';
    }
    return DateTime
      .fromMillis(date, {zone: getTimezone()})
      .setLocale(getLocaleBST())
      .toFormat('dd.MM.yyyy');
  };
});

function getLocaleBST() {
if (__env.profile === profile.lu) {
    return 'en-GB';
  } 
  return '';
}

function getTimezone() {
  if (__env.profile === profile.qr) {
    return 'Australia/Queensland';
  } else if (__env.profile === profile.lu) {
    return 'Europe/London';
  } else if (__env.profile === profile.vr) {
    return 'Europe/Helsinki';
  } else if (__env.profile === profile.vale) {
    return 'America/Sao_Paulo';
  } else if (__env.profile === profile.melco) {
    return 'Asia/Hong_Kong';
  } else if (__env.profile === profile.demo) {
    return 'Europe/Helsinki';
  } else {
    return 'UTC';
  }
}

function parseReceivedDate(date) {
  // VALE uses mixed payload formats across endpoints:
  // 1) timezone suffix present (Z / +/-HH:mm): treat as timezone-naive local
  //    clock value (legacy backend behavior with fake zone suffix)
  // 2) no timezone suffix: treat as genuine UTC
  if (__env.profile === profile.vale) {
    const hasTimezoneSuffix = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(date);

    if (hasTimezoneSuffix) {
      const parsedWithSourceZone = DateTime.fromISO(date, { setZone: true });
      return parsedWithSourceZone.setZone(getTimezone(), { keepLocalTime: true });
    }
  }

  // All other profiles (or VALE without timezone suffix): treat as genuine UTC
  return DateTime.fromISO(date, { zone: 'utc' });
}

ekeFilters.filter('eventLevelName', function ($translate) {
  return function (level) {
    let name = '';
    if (level === 2) {
      name = 'alarm';
    } else if (level === 1) {
      name = 'warning';
    } else if (level === 0) {
      name = 'indicator';
    }
    return $translate.instant('event-class.' + name);
  };
});

ekeFilters.filter('operationMode', function ($translate) {
  return function (mode) {
    let name = '';
    if (mode === 'ON_DEPOT') {
      name = 'On Depot';
    } else if (mode === 'ON_MAINTENANCE') {
      name = 'On Maintenance';
    } else if (mode === 'OUT_OF_SERVICE') {
      name = 'Out of Service';
    } else if (mode === 'IN_SERVICE') {
      name = 'In Service';
    } else if (mode === 'UNKNOWN') {
      name = 'Unknown';
    } else if (mode === 'ON_DEPOT_MAINTENANCE') {
      name = 'On Depot Maintenance';
    }
    return name;
  };
});

ekeFilters.filter('operationModeIconfilter',  function() {
  return function(mode){
    let iconFaClass = '';
    if (mode === 'ON_DEPOT') {
      iconFaClass = 'fa-warehouse';
    } else if (mode === 'ON_MAINTENANCE' || mode === 'ON_DEPOT_MAINTENANCE') {
      iconFaClass = 'fa-tools';
    } else if (mode === 'IN_SERVICE' || mode === 'OUT_OF_SERVICE') {
      iconFaClass = 'fa-train train-icon-in-out-service';
    } else if (mode === 'UNKNOWN') {
      iconFaClass = 'fa-question-circle';
    }
    return iconFaClass;
  };
});

// Capitalize target names that return uppercase from backend
// except for EMU, which should be displayed as is.
ekeFilters.filter('capitalizeTarget', function () {
  return function (value) {
    if (value === 'EMU') {
      return value;
    }
    const lowercased = value.toLowerCase();
    return lowercased.charAt(0).toUpperCase() + lowercased.slice(1);
  };
});

// Based on the API specification, speed should be multiplied by 0.1
// JHAMP20_Rev.C 2.1.12 Active train info "Speed (0.1km/h/bit)"
ekeFilters.filter('formatSpeedMelco', function () {
  return function (value) {
    if (value == null) {
      return value;
    }
    // Round to preserve one decimal
    return (value * 0.1).toFixed(1);
  };
});

// Return scripts that match the state prop
// state === true, scripts that are active
// state === false, scripts that are inactive
ekeFilters.filter('scriptState', function () {
  return (collection, state) => {
    if (!collection) return;
    return collection.filter(value => value.active === state);
  };
});

ekeFilters.filter('eventClass', function () {
  return function (value) {
    if (value === 2) {
      return 'Alarm';
    } else if (value === 1) {
      return 'Warning';
    } else if (value === 0) {
      return 'Indicator';
    }
  };
});

ekeFilters.filter('textLimit', function () {
  return function (input, limit) {
    input = input || '';
    let out;

    if (limit === 0 || input.length <= limit) {
      out = input;
    } else {
      out = input.substring(0, limit) + '...';
    }
    return out;
  };
});

ekeFilters.filter('TrainNumbersFilter', function () {
  return function (dataArray, searchTerm) {
    // If no array is given, exit.
    if (!dataArray) {
      return;
    }
    // If no search term exists, return the array unfiltered.
    else if (!searchTerm) {
      return dataArray;
    }
    // Otherwise, continue.
    else {
      const lowercased = searchTerm.toLowerCase();
      return dataArray.filter(function (item) {
        return item.number.toString().indexOf(lowercased) > -1 
        || item.allVariables.toString().toLowerCase().indexOf(lowercased) > -1;
      });
    }
  };
});

ekeFilters.filter('StationsFilter', function () {
  return function (dataArray, searchTerm) {
    // If no array is given, exit.
    if (!dataArray) {
      return;
    }
    // If no search term exists, return the array unfiltered.
    else if (!searchTerm) {
      return dataArray;
    }
    // Otherwise, continue.
    else {
      const lowercased = searchTerm.toLowerCase();
      return dataArray.filter(function (item) {
        return item.id.toString().indexOf(searchTerm) > -1 
        || item.name.toString().toLowerCase().indexOf(lowercased) > -1 
        || item.abbreviation.toString().toLowerCase().indexOf(lowercased) > -1 
        || item.allVariables.toString().toLowerCase().indexOf(lowercased) > -1;
      });
    }
  };
});

ekeFilters.filter('NameIdFilter', function () {
  return function (dataArray, searchTerm) {
    // If no array is given, exit.
    if (!dataArray) {
      return;
    }
    // If no search term exists, return the array unfiltered.
    else if (!searchTerm) {
      return dataArray;
    }
    // Otherwise, continue.
    else {
      let lowercased = searchTerm.toLowerCase();
      return dataArray.filter(function (item) {
        return item.id.toString().indexOf(searchTerm) > -1 || item.name.toString().toLowerCase().indexOf(lowercased) > -1;
      });
    }
  };
});

ekeFilters.filter('NameDescIdFilter', function () {
  return function (dataArray, searchTerm) {
    // If no array is given, exit.
    if (!dataArray) {
      return;
    }
    // If no search term exists, return the array unfiltered.
    else if (!searchTerm) {
      return dataArray;
    }
    // Otherwise, continue.
    else {
      let lowercased = searchTerm.toLowerCase();
      return dataArray.filter(function (item) {
        return item.description.toString().toLowerCase().includes(lowercased)
          || item.name.toString().toLowerCase().includes(lowercased)
          || item.id.toString().includes(lowercased);
      });
    }
  };
});
